import styled from 'styled-components';
import * as variables from "pubweb-smokey/dist/components/GridSystem/_vars_widths";
import Colors from "pubweb-smokey/dist/colors";
import heroImageLg from "./consumer-affairs-hero.jpg";

export const HeroStyles = styled.div`
    @media screen and (min-width: ${variables.mobile_width_percentage}px) {
        h1 {
            animation: fadeIn 1s;
            color: #324460;
            font-family: Arial;
            font-size: 48px;
            line-height: 105%;
            padding-top: 4.0rem;
            text-align: center;
            text-shadow:
                    0 0 10px #fff,
                    0 0 15px #fff,
                    0 0 20px #fff,
                    0 0 70px #fff;
            z-index: 500;
        }
        h2 {
            background-color: rgba(150, 211, 206, 0.92);
            color: #fff;
            font-family: Arial;
            font-size: 19px;
            font-weight: 700;
            line-height: 100%;
            margin: 0;
            padding: 1.4rem 0;
            text-align: center;
        }
        .hero-image {
            background-image: url(${heroImageLg});
            background-size: cover;
            background-position: center;
            padding-bottom: 2.0rem;
            padding-top: 1px;
        }
        .form-container {
            animation: pulse 1s;
            animation-delay: 500ms;
            margin: 0 auto;
            max-width: 300px;
            width: 72%;

            .form-wrapper {
                position: relative;
            }
            fieldset {
                border: 0;
            }
            .disabled-overlay {
                background-color: rgba(0, 0, 0, .5);

                height: 100%;
                left: 0;
                margin: -15px 0 0 0;
                padding: 0 0 15px 0;
                position: absolute;
                text-align: center;
                top: 0;
                width: 100%;

                .overlay-text {
                color: #fff;
                font-weight: bold;
                padding-top: 100px;
                }
            }
        }        
        .form-content {
            background-color: #fff;
            margin-top: 0;
            padding-top: 1px;
        }
        p {
            color: #324460;
            font-family: Arial;
            font-size: 11px;
            font-weight: 600;
            line-height: 110%;
            margin: 9px auto;
            text-align: center;
            width: 85%;
        }
        form {
            margin: 0 auto;
            width: 85%;
        }
        .form-row {
            clear: both;
            display: flex;
            justify-content: space-between;
            width: 100%;
        }
        .form-name {
            width: 47%;

            .form-invalid-feedback {
            margin-bottom: 0;
            }
        }
        input {
            border: solid 1px #d6d6d6;
            border-radius: 0.2rem;
            box-sizing: border-box;
            font-size: 13px;
            padding: 10px 0 10px 4px;
            width: 100%;
        }
        .form-email {
            width: 100%;
        }
        .form-invalid-feedback {
            color: #f00;
            height: 20px; 
            margin-bottom: 0;
            opacity: 0;

            &.is-invalid {
                opacity: 1;
                display: block;
                font-family: Arial;
                font-size: 10px;
                line-height: 110%;
                margin-bottom: 10px;
            }
        }
        .form-zip {
            width: 28%;
        }
        .form-phone {
            width: 68%;
        }
        .required-text {
            color: #939393;
            font-size: 10px;
            font-weight: normal;
            margin: 2px 0;
            padding: 0;
            text-align: right;
            width: 100%;
        }
        label {
            color: #939393;
        }
        button, .submit-btn {
            background: #40b0f7;
            background: linear-gradient(to bottom, #40b0f7 0%, #0976bc 100%);
            border-radius: 8px;
            color: #fff;
            cursor: pointer;
            display: block;
            font-size: 16px;
            font-weight: normal;
            margin-bottom: 13px;
            padding: 12px 0;
            text-decoration: none;
            width: 100%;
        }
        .thank-you {
            font-size: 1.3rem;
            margin: 1rem auto;
            padding-bottom: 1rem;
            text-align: center;
            width: 90%;
        }
    }

    @media screen and (min-width: 768px) {
        h1 {
            font-size: 68px;
            padding-top: 0;
        }
        h2 {
            font-size: 24px;
            padding: 18px 0;
        }
        p {
            font-size: 15px;
            font-weight: 550;
            margin: 3px auto;
            padding: 16px 0;
        }
        .form-container {
            width: 37%;
            margin: 0 0 0 61%;
        }
        input {
            padding: 10px 0 10px 10px;
            font-size: 17px;
        }
        .form-invalid-feedback {
            &.is-invalid {
                font-size: 12.5px;
            }
        }
        .required-text {
            font-size: 12.5px;
            margin-top: 35px;
        }
        button, .submit-btn {
            font-size: 22px;
            margin-bottom: 20px;
            padding: 17.5px 0;
        }
    }
`;